import { appTitleHead } from "@/lib/app-document-title";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/~offline")({
  head: () => appTitleHead("offline-title"),
  component: OfflinePage
});

function OfflinePage() {
  return <div>Du är offline, gå online för att se innehållet</div>;
}
